import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { Item, ItemBranch, TaxServiceApplyType, ItemType, ItemPrice, ItemDependencySaleMethodBranch, ItemDependency } from "../model/item.model";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { LocalStoreManager, LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { take } from "rxjs/operators";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { Branch, form_control, Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { ItemCategory } from "../model/item-category.model";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { SalePriceType } from "../model/sale-price-type.model";
import { SoftWareLicenseKind } from "projects/sepidz-web-framework/src/lib/models/license-information.model";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { ChangeCachEnum } from "../../order/model/changecach.enum";
import { ClearableCache } from "../../../../../projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { CheckBrachAccessModel } from "src/app/gnr/data-center-process/chek-branch-access.model";
import { Goods } from "src/app/backoffice/inv/models/goods.model";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { LookupItem } from "projects/sepidz-web-framework/src/lib/models/lookup-item.model";

@Component({
  selector: "ngx-item-form",
  templateUrl: "./item-form.component.html",
  styleUrls: ["./item-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemFormComponent extends BaseFormComponent<Item> implements AfterViewInit {
  activeTabTitle: String;
  DefaultValues: Dictionary = [];
  Prices: form_control[];
  Dependents: form_control[];
  Barcodes: form_control[];
  Branches: form_control[];
  isAccessToAllBranches = true;
  haserror: boolean = false;
  erroremessage: string;
  ItemCategoryLookup: Lookup[] = [];
  changeCachEnum: ChangeCachEnum[] = [];
  SalePriceTypeLookup: SalePriceType[] = [];
  SoftWareLicenseKind = SoftWareLicenseKind;
  MeasurementUnit: any;
  deactivateSave: boolean = false;
  isLight: boolean = false;

  showBranch: boolean = false;
  disabledTitle: boolean = false;
  previousDependents: ItemDependency[] = [];
  DataDaysWeek = [
    { Id: "0", Title: this.translate("ClientApp.FrontOffice.Catalog.Item.Saturday") },
    { Id: "1", Title: this.translate("ClientApp.FrontOffice.Catalog.Item.Sunday") },
    { Id: "2", Title: this.translate("ClientApp.FrontOffice.Catalog.Item.Monday") },
    { Id: "3", Title: this.translate("ClientApp.FrontOffice.Catalog.Item.Tuesday") },
    { Id: "4", Title: this.translate("ClientApp.FrontOffice.Catalog.Item.Wednesday") },
    { Id: "5", Title: this.translate("ClientApp.FrontOffice.Catalog.Item.Thursday") },
    { Id: "6", Title: this.translate("ClientApp.FrontOffice.Catalog.Item.Friday") },
  ];
  activeSaleMethodBranches: LookupItem[];
  currentInformation = this.accountService.authService.currentInformation();
  constructor(
    private lookupService: LookupService,
    protected cd: ChangeDetectorRef,
    protected selectorService: SelectorService,
    public storage: LocalStoreManager
  ) {
    super(selectorService, cd);
    if (!this.model) this.model = new Item();
    this.FillData();
  }
  ngAfterViewInit(): void {}
  async FillData() {
    const info = this.accountService.authService.currentInformation();
    this.isLight = info.SepidzWebKind === SoftWareLicenseKind.RestaurantLightWeb;
    if (info.BranchingLightEnabled || info.BranchingAdvancedEnabled) {
      this.httpCommonService
        .getList("UserLocalSetting/GetValidationBranch" + "/Item")
        .pipe(take(1))
        .subscribe((hbc: CheckBrachAccessModel) => {
          console.log(hbc);
          if (hbc.TransferKindCode != 3) {
            if ((hbc.TransferKindCode == 2 || hbc.TransferKindCode == 5) && hbc.HasCommunication == true && hbc.BranchCount == 1) {
              this.sts.showDialog(
                this.translate("ClientApp.FrontOffice.Catalog.Item.HasBranchCommunication"),
                this.translate("ClientApp.FrontOffice.Catalog.Item.Attention")
              );
              this.deactivateSave = true;
              return;
            } else {
              if ((hbc.TransferKindCode == 1 || hbc.TransferKindCode == 4) && hbc.BranchCount > 1) {
                this.sts.showDialog(
                  this.translate("ClientApp.FrontOffice.Catalog.Item.HasCallCenterCommunication"),
                  this.translate("ClientApp.FrontOffice.Catalog.Item.Attention")
                );
                this.deactivateSave = true;
                return;
              }
            }
          }
        });
      (error) => this.getFailedHelper(error);
    }
    const computerName: string = this.storage.getData(ClearableCache.ComputerName);
    this.httpCommonService
      .get(`LocalSetting/GetCachState` + (computerName ? "?ComputerName=" + computerName : ""))
      .pipe(take(1))
      .subscribe(async (data: any[]) => {
        if (data) {
          this.changeCachEnum = data;
          const ItemCategoryData = this.storage.getData(ClearableCache.ItemCategoryLookup);
          if (this.changeCachEnum.some((f) => f === ChangeCachEnum.Itemcategory) && ItemCategoryData?.length > 0) {
            this.ItemCategoryLookup = ItemCategoryData;
          } else {
            await this.getLookup();
          }
          const SalePriceTypeData = this.storage.getData(ClearableCache.SalePriceType);
          if (this.changeCachEnum.some((f) => f === ChangeCachEnum.SalePriceType) && SalePriceTypeData?.length > 0) {
            this.SalePriceTypeLookup = SalePriceTypeData;
            if (!this.model?.Id) {
              let salePriceTypeId = this.SalePriceTypeLookup.find((x) =>
                x.Title.match(this.translate("ClientApp.FrontOffice.Catalog.Item.Standard"))
              )?.Id;
              if (salePriceTypeId && salePriceTypeId !== 0) {
                this.model.SalePriceTypeId = salePriceTypeId;
                this.setValue("SalePriceTypeId", salePriceTypeId);
              }
            }
          } else {
            await this.getSalePriceType();
          }
        } else {
          await this.getLookup();
          this.getSalePriceType();
        }
      });
    if (!this.model?.Id) {
      this.httpCommonService
        .getList("Unit/ReadLookUp")
        .pipe(take(1))
        .subscribe(async (data: any) => {
          this.MeasurementUnit = data;
          if (!this.model?.MeasurementUnitId) {
            let mu = data.find((m) => m.Title === "ClientApp.FrontOffice.Catalog.Item.number");
            if (mu) {
              this.model.MeasurementUnitId = mu.Id;
              this.model.MeasurementUnitTitle = mu.Title;
              this.setValue("MeasurementUnitId", mu.Id);
              this.setValue("MeasurementUnitTitle", mu.Title);
            }
          }
        });
    }
  }

  async getSalePriceType() {
    this.httpCommonService
      .getList("SalePriceType")
      .pipe(take(1))
      .subscribe(async (data: SalePriceType[]) => {
        this.SalePriceTypeLookup = data;
        this.storage.savePermanentData(data, ClearableCache.SalePriceType);
        if (!this.model?.Id) {
          let salePriceTypeId = data.find((x) => x.Title.match(this.translate("ClientApp.FrontOffice.Catalog.Item.Standard")))?.Id;
          if (salePriceTypeId && salePriceTypeId !== 0) {
            this.model.SalePriceTypeId = salePriceTypeId;
            this.setValue("SalePriceTypeId", salePriceTypeId);
          }
        }
      });
  }
  addHandler($event) {
    let ItemDependencySaleMethodBranchIds = $event?.ItemDependencySaleMethodBranch.map((e) => e.Id);
    if ($event && ItemDependencySaleMethodBranchIds.length > 0) {
      let newData: ItemDependencySaleMethodBranch[] = [];
      $event?.ItemDependencySaleMethodBranch?.forEach((element) => {
        let Ins = new ItemDependencySaleMethodBranch();
        Ins.SaleMethodId = element.Id;
        Ins.Id = 0;
        Ins.Title = element.Title;
        Ins.ItemDependencyId = $event.DependentItemId;
        Ins.State = RowState.New;
        newData.push(Ins);
      });
      if ($event.Id == 0) {
        let added = this.model.Dependents.filter((c) => c.Id == 0);
        added[added.length - 1].ItemDependencySaleMethodBranch = [...newData];
      } else {
        let existDependent = this.model.Dependents.find((c) => c.Id == $event.Id);
        existDependent.ItemDependencySaleMethodBranch = newData;
      }
    }
  }
  async ngOnInit() {
    this.apiName = "Item";
    this.label = this.translate("ClientApp.FrontOffice.Catalog.Item.Item");
    super.ngOnInit();
    this.DefaultValues["ItemId"] = 0;
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.DefaultValues = undefined;
    this.Prices = undefined;
    this.Dependents = undefined;
    this.Barcodes = undefined;
    this.Branches = undefined;
  }
  async getLookup() {
    this.httpCommonService
      .getList(`ItemCategory/GetItemCategory`)
      .pipe(take(1))
      .subscribe(
        async (data: Lookup[]) => {
          this.ItemCategoryLookup = data;
          this.storage.savePermanentData(data, ClearableCache.ItemCategoryLookup);
        },
        (error) => this.getFailedHelper(error)
      );
  }
  setdefault() {
    if (!this.model?.Branches) this.model.Branches = [];
    if (!this.model?.Prices) this.model.Prices = [];
    if (!this.model?.Dependents) this.model.Dependents = [];
    if (!this.model?.Barcodes) this.model.Barcodes = [];
    if (!this.model?.Calories) this.model.Calories = 0;
    if (!this.model?.CookingTime) this.model.CookingTime = 0;
    if (!this.model?.Tax) this.model.Tax = 0;
    if (!this.model?.Toll) this.model.Toll = 0;
    if (!this.model?.PackingPrice) this.model.PackingPrice = 0;
    if (typeof this.model.UsedInInvDailyVoucherClone === "boolean") this.model.UsedInInvDailyVoucher = true;

    if (!this.model.TaxApplyTypeId) {
      this.lookupService
        .getLookupbyCode("SALE", "TaxServiceApplyType", TaxServiceApplyType.ApplyFromGroup)
        .pipe(take(1))
        .subscribe(async (x) => {
          this.model.TaxApplyTypeId = x.Id;
          this.model.TaxApplyTypeCode = x.Code;
          this.model.TaxApplyTypeTitle = x.Title;
          this.setValue("TaxApplyTypeId", x.Id);
          this.setValue("TaxApplyTypeCode", x.Code);
          this.setValue("TaxApplyTypeTitle", x.Title);
        });
    }
    if (!this.model.ServiceApplyTypeId) {
      this.lookupService
        .getLookupbyCode("SALE", "TaxServiceApplyType", TaxServiceApplyType.ApplyFromGroup)
        .pipe(take(1))
        .subscribe(async (x) => {
          this.model.ServiceApplyTypeId = x.Id;
          this.model.ServiceApplyTypeCode = x.Code;
          this.model.ServiceApplyTypeTitle = x.Title;
          this.setValue("ServiceApplyTypeId", x.Id);
          this.setValue("ServiceApplyTypeCode", x.Code);
          this.setValue("ServiceApplyTypeTitle", x.Title);
        });
    }
    if (!this.model?.ItemTypeId) {
      this.lookupService
        .getLookupbyCode("SALE", "ItemType", ItemType.Goods)
        .pipe(take(1))
        .subscribe(async (x) => {
          this.model.ItemTypeId = x.Id;
          this.model.ItemTypeTitle = x.Title;
          this.setValue("ItemTypeId", x.Id);
          this.setValue("ItemTypeTitle", x.Title);
        });
    }
    if (!this.accountService.authService.currentBranch) {
      setTimeout(() => this.populateBranch(), 300);
    } else {
      this.populateBranch();
    }
    if (this.currentrow && this.model.DataDaysWeekTitle && typeof this.model.DataDaysWeekTitle === "string") {
      this.model.DataDaysWeekTitle = this.model.DataDaysWeekTitle.split(",");
    }
    if (this.currentrow && this.currentrow.GoodsId) {
      this.formGroup.controls["Title"].disable();
      // this.formGroup.controls["DetailLedgerId"].disable();
      this.httpCommonService
        .get("Item/UsedInInvoice/" + this.currentrow.Id)
        .pipe(take(1))
        .subscribe((isUsed: boolean) => {
          if (isUsed) this.formGroup.controls["GoodsId"].disable();
          this.formGroup.controls["Title"].disable();
          // this.formGroup.controls["DetailLedgerId"].disable();
        });
    }
    this.previousDependents = [...this.model.Dependents];
  }
  addControl() {
    if (this.formGroup) {
      this.setValue("Code", this.model?.Code);
      this.setValue("GoodsId", this.model?.GoodsId);
      this.setValue("Title", this.model.Title);
      this.setValue("Title_En", this.model.Title_En);
      this.setValue("Ingredients", this.model?.Ingredients);
      this.setValue("Ingredients_En", this.model?.Ingredients_En);
      this.setValue("CookingTime", this.model?.CookingTime);
      this.setValue("Description", this.model?.Description);
      this.setValue("Description_En", this.model?.Description_En);
      this.setValue("Calories", this.model?.Calories);
      this.setValue(`SalePriceTypeId`, this.model?.SalePriceTypeId);
      this.setValue("PackingPrice", this.model?.PackingPrice);
      this.setValue("UsedInInvDailyVoucher", this.model?.UsedInInvDailyVoucher);
      this.setValue("UsedInInvDailyVoucherClone", this.model?.UsedInInvDailyVoucherClone);
      this.setValue("Tax", this.model?.Tax);
      this.setValue("Toll", this.model?.Toll);
      this.setValue("CategoryId", this.model?.CategoryId);
      this.setValue("Price", this.model?.Price);
      this.setValue("DetailLedgerId", this.model.DetailLedgerId);
      this.setValue("ItemTypeId", this.model.ItemTypeId);
      this.setValue("TaxApplyTypeId", this.model.TaxApplyTypeId);
      this.setValue("ServiceApplyTypeId", this.model.ServiceApplyTypeId);
      this.setValue("ItemSerial", this.model.ItemSerial);
      this.setValue("DataDaysWeekTitle", this.model.DataDaysWeekTitle);
      this.setValue("StockInWeb", this.model.StockInWeb);
      this.setValue("IsOrganizationalDiscount", this.model?.IsOrganizationalDiscount);
      this.setValue("OrganizationalDiscount", this.model?.OrganizationalDiscount);
    }
    this.cd.markForCheck();
  }
  populateBranch() {
    this.httpCommonService
      .getList("Branch")
      .pipe(take(1))
      .subscribe(async (data: Branch[]) => {
        let BranchList: Branch[] = data;
        if (!this.model) this.model = <Item>{};
        if (!this.model.Branches) this.model.Branches = [];
        BranchList?.forEach((br: Branch) => {
          const listBranch = this.model.Branches.find((x) => x.BranchId === br.Id);
          if (!listBranch) {
            let entity = <ItemBranch>{};
            entity.BranchId = br.Id;
            entity.BranchTitle = br.Title;
            entity.IsActive = true;
            entity.State = RowState.New;
            if (!this.model || !(this.model.Id > 0)) {
              //اگر در مد ایجاد بودیم
              entity.Selected = true;
            } else {
              entity.Selected = false;
            }

            this.model.Branches.push(entity);
            this.cd.markForCheck();
          } else {
            listBranch.Selected = true;
          }
        });

        this.showBranch = true;
      });
  }
  setHeaderInfo() {
    let salePriceTypeId = this.formGroup.controls["SalePriceTypeId"].value;
    let price = this.formGroup.controls["Price"].value;
    let havePricesItem = false;
    let haveIsDefaultNumber = false;
    if (this.model?.Prices) {
      havePricesItem = this.model?.Prices.some((x) => x.State !== RowState.Delete && x.State !== RowState.Detached);
      haveIsDefaultNumber = this.model?.Prices.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).some((a) => a.IsDefault);
    }
    //اگر قیمت در هدر تغییر کرده باشد یا کالا شامل هیچ قیمتی نباشد
    if (
      salePriceTypeId &&
      price != null &&
      price != undefined &&
      price !== "" &&
      (this.model?.Price != price || this.model?.SalePriceTypeId != salePriceTypeId || !havePricesItem || !haveIsDefaultNumber)
    ) {
      let findIndex = this.model?.Prices.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached).findIndex(
        (x) => x.SalePriceTypeId === salePriceTypeId && x.Price === price && !x.IsDefault
      );
      if (findIndex === -1) {
        let defaultPrice: ItemPrice = <ItemPrice>{};
        defaultPrice.State = RowState.New;
        defaultPrice.IsDefault = true;
        defaultPrice.SalePriceTypeId = salePriceTypeId;
        defaultPrice.Price = price;
        if (!this.model?.Prices) {
          this.model.Prices = [];
          this.setValue("Price", "0");
        } else {
          let isFound: boolean = false;
          this.model?.Prices.filter((x) => x.State != RowState.Detached).forEach((x) => {
            if (x.IsDefault === true) {
              isFound = true;
              x.SalePriceTypeId = salePriceTypeId;
              x.Price = price;
              x.State = RowState.Modify;
            }
          });
          if (!isFound) {
            this.model?.Prices.push(defaultPrice);
          }
        }
      } else {
        this.model?.Prices.forEach((x) => (x.IsDefault = false));
        this.model.Prices[findIndex].IsDefault = true;
      }
    }
  }
  beforupdate() {
    const DataDaysWeek = this.formGroup.controls["DataDaysWeekTitle"];
    if (this.model?.Dependents && this.model?.Dependents?.length > 0) {
      this.model.Dependents = this.model?.Dependents.filter((x) => x.State != RowState.Detached);
    }
    if (this.model?.Barcodes && this.model?.Barcodes.length > 0) {
      this.model.Barcodes = this.model?.Barcodes.filter((x) => x.State != RowState.Detached);
    }
    this.model.Branches = this.model?.Branches?.filter((x) => x.Selected);
    if (this.model?.Branches && this.model?.Branches.length <= 0) this.model.Branches = null;
    if (this.model?.Dependents && this.model?.Dependents.length <= 0) this.model.Dependents = null;
    if (this.model?.Prices && this.model?.Prices.length <= 0) this.setValue("Price", "0");
    if (this.model?.Barcodes && this.model?.Barcodes.length <= 0) this.model.Barcodes = null;
    if (!this.model?.Prices) this.setValue("Price", "0");
    if (DataDaysWeek?.value && typeof DataDaysWeek?.value !== "string") DataDaysWeek.setValue(DataDaysWeek.value.join());
    if (
      this.model?.Id &&
      this.model.Dependents &&
      this.model.Dependents.length > 0 &&
      this.previousDependents &&
      this.previousDependents.length > 0
    ) {
      this.model.Dependents?.forEach((dependent) => {
        const previousDependent = this.previousDependents?.find((x) => x.Id === dependent.Id);
        dependent.ItemDependencySaleMethodBranch?.forEach((s) => {
          if (previousDependent?.ItemDependencySaleMethodBranch.some((x) => x.Id === s.Id)) {
            s.State = RowState.NoChange;
          } else if (!previousDependent?.ItemDependencySaleMethodBranch.some((x) => x.Id === s.Id)) {
            s.State = RowState.New;
          }
        });
        previousDependent?.ItemDependencySaleMethodBranch?.forEach((p) => {
          const isItemExists = dependent.ItemDependencySaleMethodBranch.some((s) => s.Id === p.Id);
          if (!isItemExists) {
            p.State = RowState.Delete;
            dependent.ItemDependencySaleMethodBranch.push(p);
          }
        });
      });
    }
  }

  onChange($event: any) {
    let itemCategory = $event as ItemCategory;
    if (this.isNewRow && itemCategory !== undefined && itemCategory.ParentId === undefined) {
      this.httpCommonService
        .getItem(this.apiName + "/GetMaxCode", itemCategory.Id)
        .pipe(take(1))
        .subscribe((data: number) => {
          if (data) this.formGroup.controls["Code"].setValue(data);
        });
    }
    let data = $event as Lookup;
    if (data && data.Category) {
      if (this.model?.TaxApplyTypeId === data.Id) {
        this.model.TaxApplyTypeCode = data.Code;
        this.model.TaxApplyTypeTitle = data.Title;
      }
      if (this.model?.ServiceApplyTypeId === data.Id) {
        this.model.ServiceApplyTypeCode = data.Code;
        this.model.ServiceApplyTypeTitle = data.Title;
      }
    }
  }
  isValid() {
    this.setHeaderInfo();
    this.erroremessage = undefined;
    this.haserror = false;
    const priceValue = this.formGroup.controls["Price"].value;

    if (this.formGroup.controls["Code"].value && this.formGroup.controls["Code"].value > 1000000000000000000) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Catalog.Item.Warning"),
        this.translate("ClientApp.FrontOffice.Catalog.Item.CodeFieldLengthValue")
      );
      return false;
    }
    if (!this.formGroup.controls["Title"].value) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Catalog.Item.Warning"),
        this.translate("ClientApp.FrontOffice.Catalog.Item.TitleNotEntered")
      );
      return false;
    }
    if (this.formGroup.controls["Title"].value && this.formGroup.controls["Title"].value.length > 50) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Catalog.Item.Warning"),
        this.translate("ClientApp.FrontOffice.Catalog.Item.TitleFieldLengthValue")
      );
      return false;
    }
    if (this.formGroup.controls["Title_En"].value && this.formGroup.controls["Title_En"].value.length > 40) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Catalog.Item.Warning"),
        this.translate("ClientApp.FrontOffice.Catalog.Item.LengthValueOfEnglishTitleField")
      );
      return false;
    }
    if (this.formGroup.controls["Ingredients"].value && this.formGroup.controls["Ingredients"].value.length > 255) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Catalog.Item.Warning"),
        this.translate("ClientApp.FrontOffice.Catalog.Item.IngredientFieldLengthValue")
      );
      return false;
    }
    if (this.formGroup.controls["Ingredients_En"].value && this.formGroup.controls["Ingredients_En"].value.length > 255) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Catalog.Item.Warning"),
        this.translate("ClientApp.FrontOffice.Catalog.Item.IngredientFieldLengthValueInEnglish")
      );
      return false;
    }
    if (this.formGroup.controls["Calories"].value && this.formGroup.controls["Calories"].value > 100000000000) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Catalog.Item.Warning"),
        this.translate("ClientApp.FrontOffice.Catalog.Item.LengthOfCalorieField")
      );
      return false;
    }
    if (this.formGroup.controls["CookingTime"].value && this.formGroup.controls["CookingTime"].value > 100000000000) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Catalog.Item.Warning"),
        this.translate("ClientApp.FrontOffice.Catalog.Item.CookingTimeFieldLengthValue")
      );
      return false;
    }
    if (this.formGroup.controls["Tax"].value && this.formGroup.controls["Tax"].value > 1000) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Catalog.Item.Warning"),
        this.translate("ClientApp.FrontOffice.Catalog.Item.LengthOfTaxField")
      );
      return false;
    }
    if (this.formGroup.controls["Toll"].value && this.formGroup.controls["Toll"].value > 1000) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Catalog.Item.Warning"),
        this.translate("ClientApp.FrontOffice.Catalog.Item.LengthOfTheTollField")
      );
      return false;
    }
    if (this.formGroup.controls["PackingPrice"].value && this.formGroup.controls["PackingPrice"].value > 100000000000) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Catalog.Item.Warning"),
        this.translate("ClientApp.FrontOffice.Catalog.Item.PackageFieldLengthValue")
      );
      return false;
    }
    if (!this.formGroup.controls["MeasurementUnitId"].value) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Catalog.Item.Warning"),
        this.translate("ClientApp.FrontOffice.Catalog.Item.MeasurementUnitNotEntered")
      );
      return false;
    }

    if (priceValue === null || priceValue === "" || priceValue < 0) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Catalog.Item.Warning"),
        this.translate("ClientApp.FrontOffice.Catalog.Item.DefaultPriceNotEntered")
      );
      return false;
    }

    if (!this.formGroup.controls["ItemTypeId"].value) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Catalog.Item.Warning"),
        this.translate("ClientApp.FrontOffice.Catalog.Item.typeNotEntered")
      );
      return false;
    }
    if (this.model?.Prices && this.model?.Prices.length > 0) {
      this.model.Prices = this.model?.Prices.filter((x) => x.State != RowState.Detached);
    }
    if (!this.model?.Prices || this.model?.Prices.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached).length < 0) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.FrontOffice.Catalog.Item.AtLeastOnePriceIsRequired");
    }
    if (!this.formGroup.controls["CategoryId"].value) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Catalog.Item.Warning"),
        this.translate("ClientApp.FrontOffice.Catalog.Item.ItemsWithoutGroupHeadShouldBeDefinedInDishesMenu")
      );
    }

    let codeIsValid = true;
    if (!this.formGroup.controls["Code"].value || this.formGroup.controls["Code"].value === "0") {
      codeIsValid = false;
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Catalog.Item.CodeIsRequired"),
        this.translate("ClientApp.FrontOffice.Catalog.Item.Attention")
      );
    }

    if (
      this.model?.Id &&
      this.model?.Dependents &&
      this.model?.Dependents.length > 0 &&
      this.model?.Dependents.some((i) => i.State != RowState.Delete && i.State != RowState.Detached && i.DependentItemId == this.model?.Id)
    ) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.FrontOffice.Catalog.Item.ProductAmongDependentProducts");
    }
    return !this.haserror && codeIsValid;
  }
  onGoodsIdChanges(goods: Goods) {
    if (goods) {
      this.setValue("Title", goods.Title);
      this.model.Title = goods.Title;
      this.setValue("MeasurementUnitId", goods.UnitId);
      this.model.MeasurementUnitId = goods.UnitId;
      this.setValue("DetailLedgerId", goods.DetailLedgerId);
      this.model.DetailLedgerId = goods.DetailLedgerId;
      this.setValue("Code", goods.Code);
      this.model.Code = +goods.Code;
      this.formGroup.controls["Title"].disable();
      this.formGroup.controls["DetailLedgerId"].disable();
      this.disabledTitle = true;
    }
  }

  onGoodsClear() {
    this.setValue("Title", "");
    this.model.Title = "";
    this.setValue("Code", "");
    this.model.Code = null;
    this.setValue("MeasurementUnitId", null);
    this.model.MeasurementUnitId = null;
    this.setValue("DetailLedgerId", null);
    this.model.DetailLedgerId = null;
    this.formGroup.controls["Title"].enable();
    this.formGroup.controls["DetailLedgerId"].enable();
    this.disabledTitle = false;
  }

  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
  }
  setMaxCode() {
    setTimeout(() => {
      document.getElementById("Title")?.focus();
    }, 700);
  }
  setColumnAttribute() {
    super.setColumnAttribute();
    this.Prices = this.getDetailControlModels("Prices");
    this.Dependents = this.getDetailControlModels("Dependents");
    this.Barcodes = this.getDetailControlModels("Barcodes");
    this.Branches = this.getDetailControlModels("Branches");
    if (this.Dependents.findIndex((c) => c.name == "ItemDependencySaleMethodBranch") != -1)
      this.Dependents = this.Dependents.filter((c) => c.name != "ItemDependencySaleMethodBranch");
    this.Dependents.push({
      name: "ItemDependencySaleMethodBranch",
      modelName: "ItemDependencySaleMethodBranch",
      listVisible: true,
      label: this.translate("ClientApp.FrontOffice.Catalog.Item.SellMethod"),
      IsMultiSelect: true,
      controlType: FormControlTypes.dropdown,
      order: 0,
      textType: "number",
      formVisible: true,
      disabled: false,
      areaName: "default",
      apiName: "SaleMethodBranch/GetActiveSaleMethodBranch",
      displayMember: "Title",
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
      columnWidth: 200,
      required: false,
    });
    if (this.model?.Id) {
      this.httpCommonService
        .getList("SaleMethodBranch/GetActiveSaleMethodBranch")
        .pipe(take(1))
        .subscribe((res: LookupItem[]) => {
          this.activeSaleMethodBranches = res;
          this.model.Dependents.forEach((dependent) => {
            dependent.ItemDependencySaleMethodBranch.forEach((saleMethod) => {
              saleMethod.Title = res.find((c) => c.Id == saleMethod.SaleMethodId).Title;
            });
          });
        });
    }
  }

  CompleteData($event: any) {
    if ($event.apiName === "Lookup" && $event.Category === " ItemType") {
      if (!this.model?.ItemTypeId) {
        this.model.ItemTypeId = $event.Id;
        this.model.ItemTypeTitle = $event.Title;
        this.setValue("ItemTypeId", $event.Id);
        this.setValue("ItemTypeTitle", $event.Title);
      }
    }
  }

  showOrganizationalDiscount(event) {
    this.model.IsOrganizationalDiscount = null;
    this.model.IsOrganizationalDiscount = event;
    this.cd.detectChanges();
  }
}
